<template>
  <div style="padding: 10px 10px">
    <div>
      <p>
          <vue-blob-json-csv
            file-type="csv"
            file-name="Catalog_template"
            :data="data"
          >
                              <CButton
                      color="success"
>Download Template</CButton>
          </vue-blob-json-csv>
        &nbsp;Please update your product in the template provided before uploading.
      </p>
    </div>

    <div>
      <vue-csv-import
        :autoMatchFields="true"
        v-model="csv"
        :map-fields="map"
        :callback="setvalue"
      ></vue-csv-import>
    </div>
    <div v-if="items.length > 0">
      <b-table
        class="myTable"
        :items="csv"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        show-empty
        sort-icon-right
        responsive="sm"
      >
        <template v-slot:cell(foto)="data">
          <img
            v-if="data.item.image"
            :src="data.item.image"
            style="width: 100px; height: 60px; padding: 5px 5px"
          />
       
          <img
            v-else
            src="../../assets/No.png"
            class="img-fluid"
            alt="..."
            style="width: 74px; height: 60px; padding: 5px 5px"
          />
        </template>
        <template #cell(name)="item">
          <td v-if="item.item.product != ''">
            {{ item.item.product | truncate(20, "...") }}
          </td>
          <td v-if="item.item.product == ''">--</td>
        </template>
        <template #cell(catalog)="item">
          <td v-if="item.item.catalog != ''">
            {{ item.item.catalog | truncate(10, "...") }}
          </td>
          <td v-if="item.item.catalog == ''">--</td>
        </template>
        <template #cell(description)="item">
          <td v-if="item.item.description != ''">
            {{ item.item.description | truncate(40, "...") }}
          </td>
          <td v-if="item.item.description == ''">--</td>
        </template>
        <template #cell(price)="item">
          <td v-if="item.item.unitprice != ''">
            {{ item.item.unitprice }}
          </td>
          <td v-if="item.item.unitprice == ''">--</td>
        </template>
      </b-table>
      <div class="mat-table__bottom">
        <span style="margin-right: 20px; margin-bottom: 15px">
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </span>
        <span class="">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
          ></b-pagination>
        </span>
      </div>
    </div>
    <div style="text-align: center">
      <CButton
        v-if="items.length > 0"
        block
        color="primary"
        style="width: fit-content; height: fit-content; margin-top: 0.5rem"
        @click="emitvalues"
        >Upload</CButton
      >
    </div>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script src="./dist/VueBlobJsonCsv.umd.min.js"></script>

<script>
import { VueCsvImport } from "vue-csv-import";
import Vue from "vue";
import VueBlobJsonCsv from "vue-blob-json-csv";

Vue.use(VueBlobJsonCsv);

export default {
  name: "upload",
  components: {
    VueCsvImport,
  },
  props: {
    map: {
      type: Object,
    },
  },
  methods: {
    setvalue() {
      console.log(this.csv);

      this.totalRows = this.csv.length;

      for (let val in this.csv[0]) {
        let tval = {
          key: val,
          label: val,
        };

        this.items.push(tval);
        console.log(this.items);
      }
      // this.csv.splice(0, 1);
    },
    emitvalues() {
      this.$emit("uploadcb", this.csv);
    },
  },
  data() {
    return {
      csv: null,
      data: [
        {
          Catalogue: "",
          Category: "",
          "Sub-Category": "",
          "SKU No/Product ID": "",
          "Product Name": "",
          Brand: "",
          "Image Link": "",
          Description: "",
          "Size/Qty": "",
          "MRP (Maximum Retail Price)": "",
          "RSP (Retail Selling Price)": "",
          "% Discount": "",
          "Country of Origin": "",
          "Mfg Date": "",
          "Exp Date": "",
          "Stock Available": "",
          "Featured Product": "",
          "Bar Code": "",
          "Stock Qty": "",
        },
      ],

      items: [],
      totalRows: 1,
      active_row: "",

      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      filter: "",

      fields: [
        {
          key: "foto",
          label: "Image",
          sortable: false,
          editable: true,
          image: true,
          tbClass: "bTableThStyle",
        },
        {
          key: "catalog",
          label: "Catalog",
        },
        {
          key: "category",
          label: "Category",
        },
        {
          key: "name",
          label: "Product",
        },
        {
          key: "price",
          label: "Price",
        },

        {
          key: "description",
          label: "Description",
        },
      ],
    };
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.container {
  text-align: left;
}
pre code {
  background-color: #eee;
  border: 1px solid #999;
  display: block;
  padding: 20px;
}
#app .form {
  text-align: left;
}
.myTable thead {
  font-weight: 600;
  font-family: "Montserrat";
  font-size: 18px;
  color: #3b4859;
}
.custom-select-sm {
  font-family: "Montserrat";
}
.myTable td {
  color: #3b4859;
  font-family: "Assistant";
  font-weight: 500;
  font-size: 14px;
}
.mat-table__bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.b-pagination-pills .page-item .page-link {
  color: #3b4859;
  border: transparent;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
}
.page-item.active .page-link {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
  background: #ff0000;
  color: #fff;
  border: #ff0000;
}
.table td {
  padding: 0;
  vertical-align: 0;
  border-top: none;
  border-top-color: none;
  text-overflow: ellipsis;
}
</style>